import React from 'react';
import { SessionTimeoutProvider, useSessionTimeout } from '../../context/SessionTimeout';
import { SessionTimeoutModal } from '../Modal/SessionTimeoutModal';

/**
 * SessionTimeoutWrapper
 * 
 * Internal component that renders the modal
 * Must be inside SessionTimeoutProvider to access context
 */
const SessionTimeoutModalWrapper: React.FC = () => {
  const { showSessionTimeoutModal, handleSessionTimeoutLogin } = useSessionTimeout();
  
  return (
    <SessionTimeoutModal 
      isOpen={showSessionTimeoutModal}
      onLogin={handleSessionTimeoutLogin}
    />
  );
};

/**
 * SessionTimeoutContainer
 * 
 * Combines the provider and modal into one component
 * Wrap your app with this to enable session timeout handling
 */
interface SessionTimeoutContainerProps {
  children: React.ReactNode;
}

export const SessionTimeoutContainer: React.FC<SessionTimeoutContainerProps> = ({ children }) => {
  return (
    <SessionTimeoutProvider>
      {children}
      <SessionTimeoutModalWrapper />
    </SessionTimeoutProvider>
  );
};

export default SessionTimeoutContainer;
